export default __webpack_public_path__ + "static/media/gc.954f9cd1.png";